import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

const useQueryImmobilier = (options?: any) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["Immobilier"],
    queryFn: () => fetchApi("peoples", token).get(),
    staleTime: 10000 * 60 * 10,
    refetchOnWindowFocus: false,
  });
};

export default useQueryImmobilier;
